var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDatafound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 227,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#prefix__filter0_d_307_1776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.797 214.416c56.448 0 102.208-45.76 102.208-102.208S188.245 10 131.797 10C75.35 10 29.589 55.76 29.589 112.208s45.76 102.208 102.208 102.208z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.47 39.433h78.816c7.527 0 13.628 6.1 13.628 13.627v104.788c0 7.527-6.101 13.628-13.628 13.628H93.469c-7.526 0-13.627-6.101-13.627-13.628V53.06c0-7.526 6.1-13.627 13.627-13.627z",
    fill: "url(#prefix__paint0_linear_307_1776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.384 56.467h34.24a4.174 4.174 0 010 8.347h-34.24a4.174 4.174 0 010-8.347z",
    fill: "#E75858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.384 80.145h76.826a4.174 4.174 0 010 8.348H93.384a4.174 4.174 0 010-8.347zM93.384 103.823h76.826a4.174 4.174 0 010 8.347H93.384a4.173 4.173 0 110-8.347zM93.384 127.502h76.826a4.174 4.174 0 010 8.347H93.384a4.174 4.174 0 010-8.347zM93.384 151.18h76.826a4.173 4.173 0 110 8.347H93.384a4.174 4.174 0 010-8.347z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.464 24.84h-51.173c-2.384 0-4.317 2.035-4.317 4.545v25.312c0 2.51 1.933 4.544 4.317 4.544h51.173c2.385 0 4.317-2.034 4.317-4.544V29.385c0-2.51-1.932-4.544-4.317-4.544z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.75 47.477a5.11 5.11 0 100-10.22 5.11 5.11 0 000 10.22z",
    fill: "#CCC6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.784 37.256h17.035a5.11 5.11 0 015.11 5.11 5.11 5.11 0 01-5.11 5.11h-17.035a5.11 5.11 0 010-10.22z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.702 177.42c10.969 0 21.164-3.319 29.636-9.007l34.664 33.092 12.573-14.586-33.45-31.931a53.002 53.002 0 009.81-30.802c0-29.399-23.834-53.233-53.233-53.233-29.401 0-53.234 23.834-53.234 53.233 0 29.4 23.833 53.234 53.234 53.234zm45.405-53.234c0 24.891-20.179 45.069-45.069 45.069-24.89 0-45.068-20.178-45.068-45.069 0-24.89 20.178-45.067 45.068-45.067 24.89 0 45.069 20.177 45.069 45.067z",
    fill: "#CCC6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.034 170.126c25.637 0 46.419-20.593 46.419-45.994s-20.782-45.993-46.419-45.993c-25.637 0-46.42 20.592-46.42 45.993 0 25.401 20.783 45.994 46.42 45.994z",
    fill: "#fff",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.06 124.132l11.233-11.19a5.822 5.822 0 00-.116-8.155 5.899 5.899 0 00-4.079-1.713 5.904 5.904 0 00-4.126 1.597l-11.258 11.19-11.234-11.19a5.911 5.911 0 00-8.441-.119 5.836 5.836 0 00-1.723 4.221 5.832 5.832 0 001.843 4.169l11.252 11.19-11.252 11.19a5.828 5.828 0 00-.12 8.39 5.925 5.925 0 001.948 1.284 5.92 5.92 0 006.493-1.403l11.258-11.19 11.259 11.19a5.912 5.912 0 008.059-.26 5.836 5.836 0 001.716-3.959 5.828 5.828 0 00-1.479-4.052l-11.233-11.19z",
    fill: "#E75858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226 201.506l12.572-14.587 1.894 1.808c1.837 1.754 2.937 4.203 3.058 6.811.12 2.608-.748 5.159-2.414 7.092-1.667 1.933-3.995 3.091-6.473 3.218-2.477.127-4.901-.787-6.739-2.541l-1.893-1.807-.005.006z",
    fill: "#E1DCEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.002 62.954a16.105 16.105 0 00-.473-3.674c-1.069-4.328-5.837-7.108-10.911-7.76-5.072-.654-10.348.833-12.381 4.598-1.163 2.153-1.323 4.008-.848 5.572.473 1.557 1.596 2.846 3.12 3.852 4.248 2.8 11.689 3.371 15.084 2.201a37.983 37.983 0 004.596-1.944c-.853 4.894-4.035 9.53-8.282 13.708-9.23 9.08-23.55 15.973-31.35 18.506-.419.137-.651.601-.52 1.039.13.438.575.683.994.547 7.954-2.585 22.554-9.623 31.965-18.883 4.863-4.783 8.327-10.167 8.919-15.828C62.907 58.755 71.932 47.627 79.65 38.26a.855.855 0 00-.084-1.17.773.773 0 00-1.121.087c-7.403 8.983-15.995 19.667-26.443 25.776zm-1.598.89a14.508 14.508 0 00-.415-4.15c-.924-3.748-5.172-5.963-9.566-6.528-2.692-.346-5.46-.06-7.633.953-1.365.636-2.49 1.56-3.167 2.816-.89 1.648-1.083 3.057-.718 4.253.365 1.204 1.271 2.172 2.452 2.949 3.872 2.552 10.646 3.095 13.736 2.028a37.373 37.373 0 005.311-2.321z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.781 147.129a5.11 5.11 0 10.001-10.22 5.11 5.11 0 00-.001 10.22z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.091 190.76c1.965-.737 4.033-1.72 5.628-3.142 1.894-1.687 2.664-3.862 3.18-6.15.664-2.942.93-6.073 1.736-9.019.297-1.094.871-1.508 1.117-1.691a2.63 2.63 0 011.843-.54c.7.053 1.664.333 2.299 1.573.09.178.207.448.286.818.057.273.095 1.121.156 1.472.152.863.279 1.726.4 2.592.398 2.887.628 5.339 1.886 7.992 1.709 3.601 3.42 5.803 5.742 6.78 2.246.943 4.929.765 8.358.025.327-.082.65-.154.969-.213 1.512-.278 2.958.769 3.255 2.359.297 1.587-.664 3.134-2.163 3.484-.312.074-.62.142-.925.206-4.635 1.211-10 5.53-13.118 9.313-.96 1.166-2.367 4.428-3.802 6.507-1.059 1.536-2.25 2.546-3.25 2.905a2.775 2.775 0 01-1.699.081c-.679-.175-1.24-.563-1.672-1.179a3.442 3.442 0 01-.557-1.365c-.05-.278-.055-.983-.054-1.303-.293-1.061-.651-2.097-.912-3.168-.622-2.557-1.842-4.174-3.292-6.312-1.356-2-2.813-3.258-4.948-4.261-.277-.072-2.52-.651-3.31-.982-1.157-.488-1.709-1.305-1.909-1.745a3.502 3.502 0 01-.306-1.94c.1-.803.442-1.489 1.047-2.043.375-.344.934-.678 1.685-.842.578-.127 2.116-.201 2.33-.212zm13.151-4.165c.103.245.215.489.332.738 2.501 5.273 5.3 8.218 8.702 9.646l.113.046c-2.275 1.782-4.336 3.775-5.908 5.684-.65.788-1.507 2.422-2.435 4.096-.842-2.889-2.218-4.931-3.95-7.488-1.325-1.95-2.71-3.418-4.416-4.614 1.323-.716 2.584-1.555 3.683-2.533 1.83-1.632 3.039-3.522 3.88-5.575z",
    fill: "#CCC6D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint0_linear_307_1776",
    x1: 132.878,
    y1: 39.433,
    x2: 132.878,
    y2: 171.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "prefix__filter0_d_307_1776",
    x: 0,
    y: 0,
    width: 263.781,
    height: 226.208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_307_1776"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_307_1776",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDatafound);
export default __webpack_public_path__ + "static/media/noDatafound.91588d58777e87c21497b2cf81b7810d.svg";
export { ForwardRef as ReactComponent };